import { Truck, FileText } from 'lucide-react';
import { SideMenuModal } from './SideMenuModal';
import { colors } from '../constants/colors';
import { getAdjustedFlatRate, getAdjustedFlatRateAdditional } from '../utils/shippingCalculator';
import type { ShippingConfig } from '../types';

interface Props {
  shippingConfig: ShippingConfig | null | undefined;
  sellerNotes?: string | null;
  onClose: () => void;
}

export function NotesModal({ shippingConfig, sellerNotes, onClose }: Props) {
  const shippingText = shippingConfig
    ? [
        shippingConfig.strategy === 'FREE' && 'Free shipping on all items.',
        shippingConfig.strategy === 'FLAT_RATE' && `$${getAdjustedFlatRate(shippingConfig).toFixed(2)} first item, $${getAdjustedFlatRateAdditional(shippingConfig).toFixed(2)} each additional.`,
        shippingConfig.strategy === 'WEIGHT_BASED' && 'Calculated by weight.',
        shippingConfig.maxShippingCapEnabled && shippingConfig.maxShippingCapAmount &&
          `Max shipping per show: $${shippingConfig.maxShippingCapAmount.toFixed(2)}.`,
        shippingConfig.freeShippingThresholdEnabled && shippingConfig.freeShippingThresholdAmount &&
          `Free shipping on all orders over $${Math.floor(shippingConfig.freeShippingThresholdAmount)}!`,
      ].filter(Boolean).join(' ')
    : '';

  const hasContent = !!shippingConfig || !!sellerNotes;

  return (
    <SideMenuModal title="Notes" onClose={onClose} maxWidth={420}>
      {!hasContent ? (
        <p style={{ margin: 0, color: colors.gray[600], fontSize: 14 }}>
          No additional notes from this seller.
        </p>
      ) : (
        <>
          {shippingConfig && (
            <section style={{ marginBottom: sellerNotes ? 20 : 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
                <Truck size={16} color={colors.brand.blue} />
                <span style={{ fontSize: 14, fontWeight: 600, color: colors.ink.black }}>Shipping Info</span>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: colors.gray[600], lineHeight: 1.55 }}>{shippingText}</p>
            </section>
          )}
          {shippingConfig && sellerNotes && (
            <div style={{ height: 1, background: colors.gray[100], margin: '16px 0' }} />
          )}
          {sellerNotes && (
            <section>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
                <FileText size={16} color={colors.brand.blue} />
                <span style={{ fontSize: 14, fontWeight: 600, color: colors.ink.black }}>Seller Notes</span>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: colors.ink.black, lineHeight: 1.55, whiteSpace: 'pre-wrap' }}>
                {sellerNotes}
              </p>
            </section>
          )}
        </>
      )}
    </SideMenuModal>
  );
}
